/* storybook-check-ignore */
import { useMemo } from 'react';
import { useRequestATourContext } from './useRequestATour';
import { Flex, Text, Link } from '@opendoor/bricks/core';
import moment from 'moment-timezone';
import { DEFAULT_TIMEZONE, SLOT_DATE_TIME_FORMAT, SLOT_TIME_FORMAT } from './util';
import { Listing } from 'declarations/exclusives/listing';

export default function TourRequested({ listing }: { listing: Listing }) {
  const timezone = listing.timezone || DEFAULT_TIMEZONE;
  const { data } = useRequestATourContext();
  const { isConfirmed, slots } = useMemo(() => {
    const isConfirmed = !!data?.fulfilled_at;
    const slots = data?.exclusive_tour_request_time_slots;
    return {
      isConfirmed,
      slots: isConfirmed ? slots?.filter(({ selected_time_slot }) => selected_time_slot) : slots,
    };
  }, [data]);
  if (!slots) return null;
  return (
    <Flex
      flexDirection="row"
      justifyContent="space-between"
      flexWrap="wrap"
      gridGap="0.5rem"
      paddingY="0.75rem"
      paddingX="1rem"
      borderRadius="roundedSquare"
      border="1px solid"
      borderColor="neutrals40"
      alignItems="flex-start"
    >
      <Flex flexDirection="column">
        <Text fontSize="s1" fontWeight="semibold">
          Tour {isConfirmed ? 'confirmed' : 'requested'}. Check email and text for details.
        </Text>
        {slots.map((slot, i) => (
          <Text key={`slotTourRequestedTimeSlotInfo${i}`} fontSize="s1">
            {`${moment(slot.start_time).tz(timezone).format(SLOT_DATE_TIME_FORMAT)} - ${moment(
              slot.end_time,
            )
              .tz(timezone)
              .format(SLOT_TIME_FORMAT)}${i !== slots.length - 1 ? ',' : ''}`}
          </Text>
        ))}
      </Flex>
      <Link
        fontWeight="semibold"
        aria-label={null}
        analyticsName=""
        href="tel:(512) 706-9938"
        alignItems="center"
        display="inline-flex"
        color="brand50"
      >
        Call us for questions
      </Link>
    </Flex>
  );
}
